import { jsx as _jsx } from "react/jsx-runtime";
import { Controller, useField } from "@madmedical/form";
import BaseMultiSelect from "../molecules/Form/MultiSelect";
const MultiSelect = (props) => {
    const { control, isError, error } = useField(props.name);
    return (_jsx(Controller, { name: props.name, control: control, rules: { required: props.isRequired }, render: ({ field: { onBlur, onChange, value } }) => (_jsx(BaseMultiSelect, Object.assign({}, props, { onBlur: onBlur, onChange: onChange, values: value, isInvalid: isError, error: error, maxItems: props.maxItems }))) }));
};
export default MultiSelect;
